import styled from 'styled-components';

export const StyledYelp = styled.div``;
